import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  PasswordRecoveryRequest,
  PasswordRecoveryResponse
} from './passwordRecovery.types'

export const passwordRecovery = async (request: PasswordRecoveryRequest) => {
  const response = await authApi.post<PasswordRecoveryResponse>(
    'password-recovery',
    request
  )
  return response.data
}

export const usePasswordRecoveryMutation = (
  options?: ExtendableMutationOptions<
    PasswordRecoveryResponse,
    PasswordRecoveryRequest
  >
) => {
  return useMutation({
    mutationFn: passwordRecovery,
    ...options
  })
}
